import React from 'react';
import { LoadingContainer } from 'app/components/LoadingContainer';
import { lazyLoad } from 'utils/loadable';

export const RestaurantReservationResult = lazyLoad(
  () => import('./detailPage'),
  module => module.RestaurantReservationResultPage,
  { fallback: <LoadingContainer loading /> },
);
